/**
 * URL バリデーション関連のユーティリティ関数
 */

/**
 * Google SpreadsheetのURL検証
 * @param url 検証するURL
 * @returns エラーメッセージ（問題なければ空文字）
 */
export const validateGoogleSpreadsheetUrl = (url: string): string => {
  if (!url || url.trim() === '') {
    return '医師診療リストスプレッドシートURLは必須です';
  }

  const trimmedUrl = url.trim();

  // Google Spreadsheet URLパターン
  // 許可形式: https://docs.google.com/spreadsheets/d/{spreadsheet-id}/...
  const googleSpreadsheetPattern = /^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9_-]+/;

  if (!googleSpreadsheetPattern.test(trimmedUrl)) {
    return 'GoogleスプレッドシートのURLを入力してください（例: https://docs.google.com/spreadsheets/d/xxx）';
  }

  return '';
};
